module.exports = __webpack_public_path__ + "assets/img/DS-room3 (12).8167ab7d.jpg";